import { render, staticRenderFns } from "./distrIndex.vue?vue&type=template&id=92550998&"
import script from "./distrIndex.vue?vue&type=script&lang=js&"
export * from "./distrIndex.vue?vue&type=script&lang=js&"
import style0 from "./distrIndex.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports